import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../data/content';
import { Overline } from './Overline';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream py-24 lg:py-32" data-id="element-183" data-mp="1gjbyvjzz090m">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-184" data-mp="1gjvid559r5gr">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-185" data-mp="248xyu9o62s9o">
          <div className="lg:col-span-4" data-id="element-186" data-mp="28arvm6v8rc4k">
            <Overline data-id="element-187" data-mp="289q8v54v5170">Dudas frecuentes</Overline>
            <h2 className="mt-6 font-serif text-[2rem] font-light leading-[1.12] text-ink sm:text-[2.4rem]" data-id="element-188" data-mp="28cm6escstnux">
              Lo que nos preguntan antes de empezar
            </h2>
            <p className="mt-6 text-[13.5px] leading-relaxed text-stone-600" data-id="element-189" data-mp="1zgn19dgwfika">
              ¿Tienes una duda que no está aquí? Escríbenos por WhatsApp y te respondemos sin
              compromiso.
            </p>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-190" data-mp="14vabfwoqev1u">
            <ul className="border-t border-ink/10" data-id="element-191" data-mp="14vtq94j353bn">
              {FAQS.map((faq, i) => {
              const isOpen = open === i;
              return <li key={faq.q} className="border-b border-ink/10" data-id="element-192" data-mp="1eln0a13kxads" data-mpi={i}>
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-6 text-left transition-colors duration-200 ease-premium hover:text-walnut" data-id="element-193" data-mp="19udghh4pp19t">
                      <span className="font-serif text-[1.35rem] font-light leading-snug text-ink" data-id="element-194" data-mp="1xiod283dkesa">
                        {faq.q}
                      </span>
                      <PlusIcon className={`mt-1 h-4 w-4 shrink-0 text-walnut transition-transform duration-200 ease-premium ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-195" data-mp="35orzzg86sdm" />
                    </button>
                    <AnimatePresence initial={false} data-id="element-196" data-mp="239929cxedkix">
                      {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.24,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-197" data-mp="28712qvc3yeyq">
                          <p className="max-w-2xl pb-7 text-[13.5px] leading-relaxed text-stone-600" data-id="element-198" data-mp="2qx8vqkm3fp17">
                            {faq.a}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}